import clsx from 'clsx';

type DividerHorizontalProps = React.HTMLAttributes<HTMLHRElement>;
export const DividerHorizontal = ({
  className,
  ...props
}: DividerHorizontalProps) => {
  return (
    <hr
      {...props}
      className={clsx(
        className,
        'mx-auto my-3 block w-full border-0 border-t border-solid border-slate6 text-transparent sm:my-6'
      )}
    />
  );
};

type DividerVerticalProps = React.HTMLAttributes<HTMLHRElement>;
export const DividerVertical = ({
  className,
  ...props
}: DividerVerticalProps) => {
  return (
    <hr
      {...props}
      className={clsx(
        className,
        'block h-auto w-0 self-stretch border-0 border-r border-solid border-slate6'
      )}
    />
  );
};
